import { ElementType, Intent } from "@mobility-item-page/utilities/client";
import { Button } from "@warp-ds/react";
import type React from "react";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";
import { Icon, type IconName } from "../Icon.tsx";

interface SocialMediaLinkProps {
  type: "facebook" | "twitter" | "mail";
  url: string;
  title: string;
}

const SocialMediaLink: React.FC<SocialMediaLinkProps> = ({ type, url, title }) => {
  const { trackClick } = usePulse();

  let iconName: IconName;
  let objectId = "";
  let elementType: ElementType;
  switch (type) {
    case "facebook":
      iconName = "Facebook";
      objectId = "share-by-facebook";
      elementType = ElementType.FacebookIcon;
      break;
    case "twitter":
      iconName = "X";
      objectId = "share-by-twitter/x";
      elementType = ElementType.TwitterIcon;
      break;
    case "mail":
      iconName = "Mail";
      objectId = "share-by-email";
      elementType = ElementType.EmailIcon;
      break;
    default:
      return null;
  }

  return (
    <Button
      href={url}
      rel="nofollow noopener noreferrer external"
      title={title}
      utility
      quiet
      aria-label={title}
      target="_blank"
      className="p-12 hover:s-bg-primary/10 hover:rounded-full rounded-full"
      onClick={() =>
        // Tracking event: CE_ev08, CE_ev09, CE_ev10
        trackClick({
          name: "Share ad",
          objectId,
          elementType: elementType,
          intent: Intent.Share,
        })
      }
    >
      <Icon name={iconName} size="medium" className="block hover:s-icon-primary/100 pointer-events-none" />
    </Button>
  );
};

export default SocialMediaLink;
